export const STATUS_OPTED_IN = 'OPTED_IN';
export const STATUS_NOT_SENT = 'NOT_SENT';
export const STATUS_SENT = 'SENT';

export const TYPE_NEWSLETTER = 'NEWSLETTER';
export const TYPE_MARKETING = 'MARKETING';
export const TYPE_TOP_10 = 'TOP_10';

export const ERROR_EMAIL_ALREADY_EXIST = 'EMAIL_ALREADY_EXIST';
